export default __webpack_public_path__ + "static/media/lock-key.e4bf6402.svg";